import React from 'react'
import { SvgIcon } from '@mui/material'

export const RemoveCircleIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm4-9H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Z"
      fill="inherit"
    />
  </SvgIcon>
)
